<template>
    <div>
        <div class="container">
            <div class="wrapper certBig">CERTIFICATE OF AUTHENTICITY</div>
            <div class="amTeallight">{{olist.username}}</div>
            <div class="one" @click="close"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:"amcertf",
    props: ["olist"],
    methods:{
        close(){
            
        }
    }
}
</script>

<style scoped>
.container {
    width: 1800px;
    height: 1200px;
    padding-top: 600px;
}

.wrapper {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
}

.certBig {
    font-family: 'cocomatpro-regular';
    font-size: 2em;
    color: #00a89d;
    text-align: center;
}
</style>